// @flow
import * as React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { PasswordPolicyRule } from '../../types';
import PageHeading from '../Common/PageHeading';
import Typography from '../Common/Typography';
import ErrorAlert from '../Common/ErrorAlert';
import PasswordPolicy from './Policy/PasswordPolicy';
import PolicyRuleList from './Policy/PolicyRuleList';
import atLeast from '../../styling/atLeast';

const Body = styled.div`
  padding: 1rem;
`;

const StyledErrorAlert = styled(ErrorAlert)`
  margin-bottom: 1rem;
`;

const Container = styled.div`
  ${atLeast.medium`
    display: flex;
  `};
`;

const FormContainer = styled.div`
  margin-bottom: 2rem;

  ${atLeast.medium`
    flex-basis: 33.33%;
  `};

  ${atLeast.large`
    flex-basis: 20%;
  `};
`;

const RulesContainer = styled.div`
  font-size: 0.875rem;
`;

type Props = {
  oldPassword: string,
  newPassword: string,
  passwordConfirmation: string,
  isNewPasswordValid: boolean,
  showPassword: boolean,
  rules: Array<PasswordPolicyRule>,
  errors: Array<string>,
  onChange: SyntheticInputEvent<HTMLInputElement> => mixed,
  onChangeShowPassword: () => void,
  onCancel: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => mixed
};

const PasswordResetPageDisplay = React.memo<Props>((props: Props) => (
  <>
    <PageHeading>
      <Typography kind="h3">Reset Password</Typography>
      <FontAwesomeIcon icon="key" size="lg" />
    </PageHeading>
    <Body>
      <StyledErrorAlert errors={props.errors} />
      <Container>
        <FormContainer>
          <PasswordPolicy {...props} allowSubmit={props.isNewPasswordValid} />
        </FormContainer>
        <RulesContainer>
          <PolicyRuleList value={props.newPassword} rules={props.rules} />
        </RulesContainer>
      </Container>
    </Body>
  </>
));

export default PasswordResetPageDisplay;
